import React, { useState } from "react";
import { IconContext } from "react-icons";
// import { FaRegFileImage } from "react-icons/fa";
import { AiOutlineClose } from "react-icons/ai";
import { domain } from "./../../../../../global/domain";

const PreviewImage = ({ file, deleteOne }) => {
  const [hover, setHover] = useState(false);

  return (
    <div
      onMouseOver={() => setHover(true)}
      onMouseOut={() => setHover(false)}
      className="flex flex-col items-center space-y-2 md:text-xs 2xl:text-lg cursor-pointer">
      {/* {!file.size && (
        <IconContext.Provider
          value={{ size: "8em", style: { color: "#fed7e2" } }}
        >
          <FaRegFileImage></FaRegFileImage>
        </IconContext.Provider>
      )} */}
      {/* {file.size && <img src={URL.createObjectURL(file)} alt="somePreview" />}
      <p className="text-center break-all">{name}</p>
    </div> */}
      <a
        href={file.uploaded_image}
        className="flex flex-col items-center space-y-2"
        target="_blank"
        rel="noreferrer">
        <img src={file.uploaded_image} alt="somePreview" />
        {!hover && (
          <p className="text-center break-all">
            {file.uploaded_image.replace(`http://${domain}/media/images/`, "")}
          </p>
        )}
      </a>
      {hover && (
        <div onClick={deleteOne}>
          <IconContext.Provider
            value={{ size: "2em", style: { color: "#e53e3e" } }}>
            <AiOutlineClose></AiOutlineClose>
          </IconContext.Provider>
        </div>
      )}
    </div>
  );
};

export default PreviewImage;
